module.exports = __webpack_public_path__ + "static/img/e4title_03.2fe01a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/e4title_03.png
// module id = XhJi
// module chunks = 0